/*
 * Copyright (C) Fraunhofer IESE 2021-2025 - Mher Ter-Tovmasyan
 *
 * SPDX-License-Identifier: AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

const requestType = {
  municipality: 'Kommune',
  solutionProvider: 'Anbietende',
  publicAuthorities: 'Öffentlicher Aufgabenträger'
};

export const requestsPage = {
  requests: 'Anfragen',
  registerRequests: 'Registrierungsanfragen',
  description: 'Behalte den Überblick über Registrierungsanfragen.',
  name: 'Name',
  type: 'Art',
  statusLabel: 'Status',
  lastUpdated: 'Zuletzt Geändert',
  empty: {
    top: 'Zur Zeit gibt es keine Registrierungsanfragen.',
    bottom:
      'Hier findest du alle Anfragen von Kommunen, Anbietern und weiteren öffentlichen Aufgabenträgern, die Teil von Deutschland.Digital werden wollen.'
  },
  info: {
    title: 'Über Registrierungsanfragen',
    content: {
      title: 'Was sind Registrierungsanfragen?',
      message:
        'Registrierungsanfragen sind Anfragen von Kommunen, Anbietern und weiteren öffentlichen Aufgabenträgern, die Teil von Deutschland.Digital werden wollen.'
    }
  },
  requestType,
  status: {
    PENDING: 'Offen',
    PROGRESS: 'In Arbeit',
    CREATED: 'Angenommen',
    REJECTED: 'Abgelehnt'
  },
  detail: {
    title: 'Anfrage über {{name}}',
    description: 'Registrierungsanfrage bearbeiten',
    comment: 'Interne Kommentare',
    history: 'Verlauf:',
    noComments: 'keine Kommentare vorhanden',
    save: 'Änderungen speichern',
    requestType,
    handle: {
      title: 'Anfrage bearbeiten',
      note: 'Kommentar oder Begründung',
      save: 'Beachte, dass getätigte Änderungen vor dem Ablehnen oder Annehmen der Anfrage automatisch übernommen werden!',
      placeholder:
        'Begründe die Entscheidung über die Registrierung auf dem DEUTSCHLAND.DIGITAL Marktplatz',
      info: 'Diese Begründung wird an die Interessenten gesendet!',
      reject: 'Ablehnen',
      accept: 'Annehmen',
      handled: 'Anfrage bereits bearbeitet: {{status}}',
      accepted: 'angenommen.',
      rejected: 'abgelehnt.',
      delete: 'Löschen',
      deleted: 'gelöscht'
    }
  }
};
